import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { AppThunkDispatch, AppState } from "../../../store";
import { PrimaryButton, SecondaryButton } from "../UI/Button/Button";
import { ThemeConsumer } from "styled-components";
import { PURCHASE_BUTTON_STYLE } from "../../../typings/typings";

const PurchaseButton: React.FC<PurchaseButtonProps> = (props) =>
{
    const { eventPurchaseUrl, showPurchaseUrl, style, ...rest } = props;

    const handleClick = () =>
    {
        if(showPurchaseUrl)
        {
            window.open(showPurchaseUrl, "_self");
        }
        else
        {
            window.open(eventPurchaseUrl, "_self");
        }
    };

    const renderButton = () =>
    {
        switch (style)
        {
            case "outline":
                return (<SecondaryButton onClick={handleClick} {...rest} />);
            default:
                return (<PrimaryButton onClick={handleClick} {...rest} />);
        }
    };

    return (
        <ThemeConsumer>
            {theme => renderButton() }
        </ThemeConsumer>
    );
};

const mapStateToProps = (state: AppState) =>
{
    return {};
};

const mapDispatchToProps = (dispatch: AppThunkDispatch) =>
    ({
        showTickets: (eventPurchaseUrl: string, showPurchaseUrl?: string) =>
        {
            if(showPurchaseUrl)
            {
                window.open(showPurchaseUrl, "_self");
            }
            else
            {
                window.open(eventPurchaseUrl, "_self");
            }
        }
    });

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type PurchaseButtonProps = PropsFromRedux & React.PropsWithChildren<{
    eventPurchaseUrl: string;
    showPurchaseUrl?: string;
    style?: PURCHASE_BUTTON_STYLE;
}>

export default connector(PurchaseButton);